const state = {
  data: {
    categories: {
      bronze: {
        discount: 0,
      },
      silver: {
        discount: 2,
      },
      gold: {
        discount: 4,
      },
    },
    limits: {
      low: 8000,
      top: 20000,
    },
    settings: {
      expire_at: 180,
      points: {
        order: 1,
        register: 1000,
        newsletter: 1000,
        profile: 2000,
        product: 200,
        post: 50,
        referee_qualified: 10000,
        referrer_qualified: 10000,
      },
      referral: {
        enabled: false,
        min_order_value: 20,
        coupon_percent: 5,
        coupon_months: 3,
        link_days: 90,
        registered_email_enabled: true,
      },
    },
  },
};

export default state;
